module.exports = __webpack_public_path__ + "static/media/Thumbs.966d4c20.db";